import type { RouteRecordRaw } from 'vue-router'

import { AdokLayout as Layout } from '@/apps/adok/app/layout'

const OfferRestrictionsPage = () =>
  import('@/apps/adok/pages/offer-restrictions').then(
    (m) => m.OfferRestrictionsPage
  )

const offerRestrictionsRoutes: RouteRecordRaw[] = [
  {
    path: '/offer-restrictions',
    component: Layout,
    children: [
      {
        path: '',
        name: 'offer-restrictions',
        component: OfferRestrictionsPage,
        meta: { title: 'Offer Restrictions' }
      }
    ]
  }
]

export default offerRestrictionsRoutes
